import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ErrorComponent } from 'src/app/components/dialogs/error/error/error.component';
import { ExpiredTokenPopupComponent } from 'src/app/components/expired-token-popup/expired-token-popup.component';
import { PopupService } from 'src/app/services/popup/popup.service';

@Injectable({
  providedIn: 'root'
})
export class ErrorService {

  constructor(private dialog: MatDialog, private popupService: PopupService) { }

  handleError(error?: any, forced = false) {
     let msg: string;
    if(error.status === 401){
      if (!this.popupService.isPopupOpen()) { 
        this.popupService.setPopupOpen(true); 
        this.dialog.open(ExpiredTokenPopupComponent, { disableClose: true }); 
      } 
    } else {
      if (error && typeof error === 'string') {
            msg = error;
          } else if (error && error.message) {
            msg = error.message;
          } else {
            msg = 'Aucune information supplémentaire';
          }
          this.dialog.open(ErrorComponent, {
            data: {
              message: msg,
              forced
            }
          });
    }
  }
  handleNullLoginIdError() {
    this.dialog.open(ErrorComponent, {
      data: {
        message: "Notre service est momentanément indisponible. Merci de réessayer dans quelques minutes.",
        forced: true
      }
   })
  }
}
